module.exports = __webpack_public_path__ + "static/img/scrollImg3.d9ea2fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scrollImg3.png
// module id = v/cI
// module chunks = 2